import React, { FC } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import { ExtractItem } from "src/utils/extractDescription";
import { PaymentResponse, PixResponse, SlipResponseTx, TedResponse } from "./ProofResponses";
import transactionLabel from "src/utils/transactionLabel";
import {
  ButtonWrapper,
  CloseIcon,
  DownloadIcon,
  InfoModal,
  Modal,
  ModalContent,
  ModalHeader,
  Section,
  SectionAccountinfo,
  SectionCPNJ,
  SectionItem,
  SectionPayerName,
  SectionTitle,
} from "../ModalConfirmOperation/styles";
import toLocaleAmount from "src/utils/toLocaleAmount";
import dateToLine from "src/utils/dateToLine";
import { documentFormatted } from "src/utils/documentFormatted";
import { Button } from "../button";
import { config } from "src/config";
import { dateFormat } from "src/utils/dateFormat";
import moment from "moment";

export const Payment: FC<{ data: ExtractItem; closeModal: () => void }> = ({ data, closeModal }) => {
  const txType = data.type.toLowerCase();

  console.log(txType);

  const naviagate = useNavigate();

  if (!txType.includes("payment")) {
    naviagate("/extract");
  }

  function printPDF() {
    if (!data) return null;

    const receiptString = JSON.stringify(data);

    localStorage.setItem("temp_receipt_to_print", receiptString);

    window.open(`${config.FRONTEND_URL}/PDF`);
  }

  const response = data.response as PaymentResponse;

  const label = transactionLabel(data);

  console.log(response);

  return (
    <>
      <ModalHeader>
        <div>
          <span>{label}</span>
          <button onClick={closeModal}>
            <CloseIcon />
          </button>
        </div>
      </ModalHeader>
      <ModalContent>
        <InfoModal>
          <div>
            {/* <span>{response?.proof?.beneficiary?.holder?.name}</span> */}
            <p>R$ {toLocaleAmount(data.amount)}</p>
          </div>
          <span>{dateToLine(data.created_at)}</span>
        </InfoModal>
        <Section>
          <SectionTitle>Favorecido</SectionTitle>
          <SectionPayerName>
            <span>NOME/INSTITUIÇÃO</span>
            <p>{response?.beneficiary?.name}</p>
          </SectionPayerName>
          <SectionCPNJ>
            <span>{response?.beneficiary?.document?.length > 11 ? "CNPJ" : "CPF"}</span>
            <p>{documentFormatted(response.beneficiary.document)}</p>
          </SectionCPNJ>
          <SectionItem>
            <span>Valor</span>
            <p>R$ {toLocaleAmount(data.amount)}</p>
          </SectionItem>
        </Section>
        <Section>
          <SectionTitle>Outras informações</SectionTitle>
          <SectionItem>
            <span>Data de vencimento</span>
            <p>{moment(response.dueDate).format("DD/MM/YYYY")}</p>
          </SectionItem>
          <SectionItem>
            <span>ID da transação</span>
            <p>{data.id}</p>
          </SectionItem>
          <SectionItem>
            <span>Data da transação</span>
            <p>{dateFormat(data.created_at)}</p>
          </SectionItem>
        </Section>
        <ButtonWrapper>
          <Button handleFunction={printPDF} Icon={DownloadIcon} title="Baixar Comprovante" />
        </ButtonWrapper>
      </ModalContent>
    </>
  );
};
